import axios from "../../interceptors/axiosInterceptor";
import {
  CREATE_CATEGORY_GLOBAL_URL,
  GET_CATEGORY_GLOBAL_LIST_URL,
  GET_CORE_CATEGORY_GLOBAL_URL,
  UNTAG_CATEGORY_ZONE_URL,
  UPDATE_CATEGORY_GLOBAL_URL,
} from "../../config/Url";
import {
  IGetQueryParams,
  ICategoryGlobalListingResponseAction,
  ICreateCategoryGlobalPayload,
} from "../../interfaces/Index";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import {
  normalizeCategoryGlobalListing,
  normalizeCoreCategoryGlobal,
  normalizeProductDetailPageCategoryGlobalListing,
} from "../../normalizer/CategoryGlobalNormalizer";
import { SOMETHING_WENT_WRONG } from "../../config/constants";

export const getCategoriesGlobalApiCall = (
  queryParam: IGetQueryParams = {},
  isProductDetailPage: boolean = false
) =>
  new Promise<ICategoryGlobalListingResponseAction>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(GET_CATEGORY_GLOBAL_LIST_URL, requestConfig)
      .then((response) => {
        if (response) {
          const data = response.data;
          const pageNumber = queryParam.page ? Number(queryParam.page) + 1 : 1;
          const isPaginatedRes =
            queryParam.page && (queryParam.page as any) > 0 && data.length >= 50
              ? true
              : false;
          resolve(
            isProductDetailPage
              ? normalizeProductDetailPageCategoryGlobalListing(
                  data,
                  pageNumber,
                  isPaginatedRes
                )
              : normalizeCategoryGlobalListing(data, pageNumber, isPaginatedRes)
          );
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const createCategoryGlobalApiCall = (
  payload: ICreateCategoryGlobalPayload
) =>
  new Promise<void>((resolve, reject) => {
    axios
      .post(CREATE_CATEGORY_GLOBAL_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getCoreCategoriesGlobalApiCall = () =>
  new Promise((resolve, reject) => {
    axios
      .get(GET_CORE_CATEGORY_GLOBAL_URL, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response.data;
          resolve(normalizeCoreCategoryGlobal(data));
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const updateCategoryGlobalApiCall = (
  id: string,
  payload: ICreateCategoryGlobalPayload
) =>
  new Promise((resolve, reject) => {
    /// let url = UPDATE_CATEGORY_URL.replace('{category_id}', (id as string));
    axios
      .post(UPDATE_CATEGORY_GLOBAL_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve(response);
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const untagCategoryZoneApiCall = (queryParam: IGetQueryParams = {}) =>
  new Promise<Array<any>>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(UNTAG_CATEGORY_ZONE_URL, requestConfig)
      .then((response) => {
        if (response) {
          resolve(response.data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
